import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import './Modal.css';

function CloseIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

function Modal({
  open,
  onClose,
  title,
  description = null,
  size = 'md',
  footer = null,
  showCloseButton = true,
  closeOnOverlayClick = true,
  closeOnEscape = true,
  children,
}) {
  const handleOpenChange = (next) => {
    if (!next && onClose) onClose();
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="ui-modal__overlay" />
        <Dialog.Content
          className={`ui-modal ui-modal--${size}`}
          onEscapeKeyDown={(e) => { if (!closeOnEscape) e.preventDefault(); }}
          onPointerDownOutside={(e) => { if (!closeOnOverlayClick) e.preventDefault(); }}
          onInteractOutside={(e) => { if (!closeOnOverlayClick) e.preventDefault(); }}
        >
          <div className="ui-modal__header">
            <div className="ui-modal__heading">
              <Dialog.Title className="ui-modal__title">{title}</Dialog.Title>
              {description && (
                <Dialog.Description className="ui-modal__description">
                  {description}
                </Dialog.Description>
              )}
            </div>
            {showCloseButton && (
              <Dialog.Close asChild>
                <button type="button" className="ui-modal__close" aria-label="Close">
                  <CloseIcon />
                </button>
              </Dialog.Close>
            )}
          </div>
          <div className="ui-modal__body">{children}</div>
          {footer && <div className="ui-modal__footer">{footer}</div>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default Modal;
